<div class="horizinns-container center horizinns-main-container-padding">
    <mat-card class="horizinns-card even-more-blur mw-80">
        <h2><i class="fa-solid fa-user-shield"></i> Admin Dashboard</h2>
        <mat-card-content>
            <div style="display:flex; flex-direction: row; width: 100%; text-align: left; justify-content: space-evenly;">
                <app-property-stats></app-property-stats>
                <app-user-stats></app-user-stats>
            </div>
        </mat-card-content>
    </mat-card>

    <div class="admin-tab-section">
        <mat-card class="horizinns-card even-more-blur">
            <mat-tab-group dynamicHeight>

                <mat-tab label="Users">
                    <ng-template matTabContent>
                        <div class="tab-content-wrapper">
                            <app-user-list></app-user-list>
                        </div>
                    </ng-template>
                </mat-tab>

                <mat-tab label="Sales Agents">
                    <ng-template matTabContent>
                        <div class="tab-content-wrapper">
                            <app-sales-agent-manger></app-sales-agent-manger>
                        </div>
                    </ng-template>
                </mat-tab>

                <mat-tab label="Forms">
                    <ng-template matTabContent>
                        <div class="tab-content-wrapper">
                            <mat-tab-group dynamicHeight>
                                <mat-tab label="Structure, Terms, & Conditions">
                                    <ng-template matTabContent>
                                        <div class="tab-content-wrapper">
                                            <app-terms-forms></app-terms-forms>
                                        </div>
                                    </ng-template>
                                </mat-tab>
                                <mat-tab label="W9 Tax Form">
                                    <ng-template matTabContent>
                                        <div class="tab-content-wrapper">
                                            <app-w9-forms></app-w9-forms>
                                        </div>
                                    </ng-template>
                                </mat-tab>
                                <mat-tab label="Listing Forms">
                                    <ng-template matTabContent>
                                        <div class="tab-content-wrapper">
                                            <app-listing-forms></app-listing-forms>
                                        </div>
                                    </ng-template>
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                    </ng-template>
                </mat-tab>

                

            </mat-tab-group>
        </mat-card>

        <mat-card class="horizinns-card even-more-blur" style="margin-top: 3em;">
            <mat-card-content>
                <app-email-logs></app-email-logs>
            </mat-card-content>
        </mat-card>

        <mat-card class="horizinns-card even-more-blur" style="margin-top: 3em;">
            <mat-card-content>
                <app-referral-urls-admin></app-referral-urls-admin>
            </mat-card-content>
        </mat-card>

        <mat-card class="horizinns-card even-more-blur" style="margin-top: 3em;">
            <mat-card-content>
                <app-property-list-admin></app-property-list-admin>
            </mat-card-content>
        </mat-card>

        <app-agent-state-map></app-agent-state-map>

    </div>

    <!-- <div>
        <mat-card>
            <mat-card-content>

                
            </mat-card-content>
        </mat-card>
    </div> -->
</div>
<!-- <div class="horizinns-container center horizinns-main-container-padding">
    <mat-card class="horizinns-card even-more-blur mw-80">
        <h2><i class="fa-solid fa-user-shield"></i> Admin</h2>
        <mat-card-content>
            <div style="display:flex; flex-direction: row; width: 100%; text-align: left; justify-content: space-evenly;">
                <app-property-stats></app-property-stats>
                <app-user-stats></app-user-stats>
            </div>
        </mat-card-content>
    </mat-card>

    <div class="admin-list-section">
        <mat-card class="horizinns-card even-more-blur center">
            <app-sales-agent-manger style="width: 100%;"></app-sales-agent-manger>
        </mat-card>
    </div>

    <div class="admin-list-section">
        <mat-card class="horizinns-card even-more-blur center">
            <app-terms-forms style="width: 100%;"></app-terms-forms>
        </mat-card>
    </div>

    <div class="admin-list-section">
        <mat-card class="horizinns-card even-more-blur center">
            <app-listing-forms style="width: 100%;"></app-listing-forms>
        </mat-card>
    </div>

</div> -->